var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "black",
    stroke: "currentColor",
    strokeWidth: 0.909091,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2349 16.8808L12 16.7391L11.7651 16.8808L6.50739 20.0542L7.90266 14.0733L7.96499 13.8061L7.75762 13.6264L3.11189 9.60185L9.22843 9.08292L9.50155 9.05975L9.60851 8.80738L12 3.16482L14.3915 8.80738L14.4985 9.05975L14.7716 9.08292L20.8881 9.60185L16.2424 13.6264L16.035 13.8061L16.0973 14.0733L17.4926 20.0542L12.2349 16.8808Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a188ac3b8bbeb1debf01aa451fdde32d.svg";
export { ForwardRef as ReactComponent };